import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=4c2d6eb8&"
import script from "./Accounts.vue?vue&type=script&lang=js&"
export * from "./Accounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c2d6eb8')) {
      api.createRecord('4c2d6eb8', component.options)
    } else {
      api.reload('4c2d6eb8', component.options)
    }
    module.hot.accept("./Accounts.vue?vue&type=template&id=4c2d6eb8&", function () {
      api.rerender('4c2d6eb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/Accounts.vue"
export default component.exports